/**
 * Max encoded `fw_abt` cookie value length. Values above this skip the cookie
 * write and rely on localStorage to avoid silent browser 4KB drops.
 */
export const FW_ABT_COOKIE_MAX_ENCODED_LENGTH = 3500

/**
 * fw_abt payloads are percent-encoded before the cookie write so no `{` or `[`
 * reaches the Cookie header. Feign (used by some merchant backends) parses
 * header values as URI templates and Pattern.compile anything after the first
 * `:` inside braces, which throws on our JSON.
 */
export function encodeABTestCookiePayload(payload: string): string {
  return encodeURIComponent(payload)
}

/**
 * Restores a cookie/localStorage payload to JSON text.
 * Parse-first so legacy raw-JSON cookies and current localStorage keep working.
 */
export function decodeABTestCookiePayload(raw: string): string {
  try {
    JSON.parse(raw)
    return raw
  } catch {
    // Not raw JSON — try percent-decoding (new cookie form after js-cookie get).
  }

  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

/**
 * True when `raw` is already valid JSON (legacy cookie / localStorage).
 * Encoded cookie values fail JSON.parse and return false.
 */
export function isRawJsonABTestCookiePayload(raw: string): boolean {
  try {
    JSON.parse(raw)
    return true
  } catch {
    return false
  }
}
